"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Image = _interopRequireDefault(require("../Image"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _getRouteFromUrl = _interopRequireDefault(require("@deosite/helpers/getRouteFromUrl"));
var __jsx = _react["default"].createElement;
var defaultProps = {
  link: "/"
};
var InspirationsLandingBox = function InspirationsLandingBox(props) {
  var label = props.label,
    description = props.description,
    image = props.image,
    _props$link = props.link,
    link = _props$link === void 0 ? defaultProps.link : _props$link;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var translations = {
    readMore: (0, _langLibrary["default"])("Read more")
  };
  var route = link && (0, _getRouteFromUrl["default"])(link);
  return __jsx(_Box["default"], {
    sx: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      pb: 100
    }
  }, __jsx(_Image["default"], {
    sx: {
      objectFit: "contain",
      aspectRatio: 1.333,
      width: "100%"
    },
    image: image,
    sizes: "(max-width: 1555px) and (min-width: 960px) 420px, (max-width: 960px) and (min-width: 10px) 100vw, 768px"
  }), __jsx(_Box["default"], {
    sx: {
      color: "main",
      bg: "beigeLight",
      p: "s8",
      textAlign: "center",
      width: "calc(100% - 90px)",
      position: "absolute",
      bottom: 0
    }
  }, __jsx(_Box["default"], {
    as: "h4",
    sx: {
      font: "heading3",
      mb: "s7"
    }
  }, label), __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s",
      mb: "s7"
    }
  }, description), __jsx(_Box["default"], {
    as: "span",
    sx: {
      font: "label2"
    }
  }, translations.readMore)), __jsx(Link, {
    route: route,
    params: {
      url: link
    }
  }, __jsx(_LinkRaw["default"], {
    title: label,
    sx: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%"
    }
  })));
};
var _default = InspirationsLandingBox;
exports["default"] = _default;